export default "__VITE_ASSET__BpfvZpWD__"